import { createReducer, on } from "@ngrx/store";
import { summaryPromptsActions } from "./summary-prompts.actions";
import { AiInsightState } from "../ai-insight.state";
import { cloneDeep } from "lodash-es";

export const summaryPromptsReducer = createReducer<AiInsightState['summaryPrompts']>(
  [],
  on(summaryPromptsActions.loadedPrompts, (_state, { summaryPrompts }) => cloneDeep(summaryPrompts))
);
